// https://markus.oberlehner.net/blog/simple-solution-to-prevent-body-scrolling-on-ios/

const contentElements = ['.js-main-content', '.js-skip-to-content', '.js-mobile-header', '.js-header', '.js-footer']

let scrollPosition = 0;
let $body = null;
if (typeof document !== 'undefined') {
    $body = document.querySelector('html');
}

export function enableLock() {
    scrollPosition = window.pageYOffset;
    $body.style.overflowX = 'hidden';
    $body.style.overflowY = 'scroll';
    $body.style.position = 'fixed';
    $body.style.top = `-${scrollPosition}px`;
    $body.style.width = '100%';

    for (let contentElement of contentElements) {
        const el = document.querySelector(contentElement);
        el.inert = true;
    }

}

export function disableLock() {
    $body.style.removeProperty('overflowX');
    $body.style.removeProperty('overflowY');
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');

    window.scrollTo(0, scrollPosition);

    for (let contentElement of contentElements) {
        const el = document.querySelector(contentElement);
        el.inert = false;
    }

}
